import { Button } from "@instructure/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SectionService } from "../../../../../services/SectionService";
import BulkFinalizeResultsModal from "./BulkFinalizeResultsModal";

const BulkFinalizeResultsButton = ({ coordinatedCourse, defaultDeadline }) => {
  const { t } = useTranslation();
  const [coordinatedSections, setCoordinatedSections] = useState({});
  const [loadingSections, setLoadingSections] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    async function fetchCoordinatedSections(courseId) {
      try {
        setLoadingSections(true);
        const sections =
          await SectionService.getSectionsByCourseAndTermIds(courseId);
        const filteredSections = {};
        Object.keys(sections).forEach((term) => {
          const unfinalizedForTerm = sections[term].filter(
            (section) => !section.finalized
          );
          if (unfinalizedForTerm.length > 0) {
            filteredSections[term] = unfinalizedForTerm;
          }
        });
        setCoordinatedSections(filteredSections);
        setLoadingSections(false);
      } catch {
        setLoadingError(true);
      }
    }
    fetchCoordinatedSections(coordinatedCourse.course_id);
  }, [coordinatedCourse]);

  return (
    <>
      <Button
        id="bulk-finalize-by-section"
        color="primary"
        size="small"
        onClick={() => setOpen(true)}
      >
        {t("analyze.bulkFinalizeResults")}
      </Button>
      <BulkFinalizeResultsModal
        open={open}
        setOpen={setOpen}
        coordinatedSections={coordinatedSections}
        setCoordinatedSections={setCoordinatedSections}
        loadingSections={loadingSections}
        loadingError={loadingError}
        defaultDeadline={defaultDeadline}
        courseCode={coordinatedCourse.course_code}
      />
    </>
  );
};

export default BulkFinalizeResultsButton;
